import React from 'react'
import {
  Box,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  makeStyles
} from '@material-ui/core'
import { ChevronLeft, ChevronRight } from '@material-ui/icons'
import { ExecutiveOption } from '../types'
import { currentPeriod, moveMonth } from '../utils'

const useStyles = makeStyles(theme => ({
  toolbar: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderBottom: '1px solid #e3e6ea'
  },
  monthControl: { display: 'flex', alignItems: 'center', background: '#fff', borderRadius: 6, padding: '4px 6px' },
  monthInput: { width: 180 },
  executiveSelect: { minWidth: 260 },
  spacer: { flexGrow: 1 }
}))

interface Props {
  admin: boolean
  executives: ExecutiveOption[]
  executiveId: string
  period: string
  onExecutiveChange: (executiveId: string) => void
  onPeriodChange: (period: string) => void
}

const PeriodFilters: React.FC<Props> = ({
  admin,
  executives,
  executiveId,
  period,
  onExecutiveChange,
  onPeriodChange
}) => {
  const classes = useStyles()
  return (
    <Box className={classes.toolbar}>
      <Box className={classes.monthControl}>
        <Tooltip title="Mes anterior">
          <IconButton aria-label="Mes anterior" onClick={() => onPeriodChange(moveMonth(period, -1))}>
            <ChevronLeft />
          </IconButton>
        </Tooltip>
        <TextField
          className={classes.monthInput}
          type="month"
          label="Período de oficina"
          value={period}
          onChange={event => onPeriodChange(event.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <Tooltip title="Mes siguiente">
          <span>
            <IconButton
              aria-label="Mes siguiente"
              disabled={period >= currentPeriod()}
              onClick={() => onPeriodChange(moveMonth(period, 1))}
            >
              <ChevronRight />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
      {admin ? (
        <FormControl className={classes.executiveSelect}>
          <InputLabel>Ejecutivo</InputLabel>
          <Select value={executiveId} onChange={event => onExecutiveChange(event.target.value as string)}>
            {executives.map(executive => (
              <MenuItem key={executive._id} value={executive._id}>
                {executive.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : null}
      <Box className={classes.spacer} />
    </Box>
  )
}

export default PeriodFilters
